import { useEffect, useState } from 'react';
import { ExternalLink, LogIn, ShieldCheck } from 'lucide-react';

interface FooterSettings {
  siteName?: string;
  copyrightOwner?: string;
  icpFilingNumber?: string;
  publicSecurityFilingNumber?: string;
  publicSecurityFilingUrl?: string;
  publicSecurityFilingIcon?: string;
  contactEmail?: string;
}

const operationLinks = [
  ['关于我们', 'about'], ['招商合作', 'partner-program'], ['联系我们', 'contact'],
  ['隐私政策', 'privacy'], ['服务条款', 'terms']
];

export function SiteFooter() {
  const [settings, setSettings] = useState<FooterSettings>({});
  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/site-settings', { signal: controller.signal, cache: 'no-store' })
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((data) => setSettings(data.settings?.frontend || {}))
      .catch(() => undefined);
    return () => controller.abort();
  }, []);
  const siteName = settings.siteName || '伊小满拼豆';
  const owner = settings.copyrightOwner || siteName;
  return <footer className="site-footer">
    <div className="site-footer-main">
      <div className="site-footer-brand"><span><ShieldCheck size={17} />{siteName}</span><p>拼豆图纸、色卡资料与创作工具。公开内容、合作商品和平台服务边界均以页面说明为准。</p></div>
      <nav aria-label="网站信息">{operationLinks.map(([label, slug]) => <a key={slug} href={`#operation/${slug}`}>{label}</a>)}<a className="site-footer-admin-link" href="/admin/"><LogIn size={13} />登录后台</a></nav>
      {settings.contactEmail && <a className="site-footer-email" href={`mailto:${settings.contactEmail}`}>{settings.contactEmail}</a>}
    </div>
    <div className="site-footer-legal">
      <span>© {new Date().getFullYear()} {owner}</span>
      {settings.icpFilingNumber && <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{settings.icpFilingNumber}<ExternalLink size={12} /></a>}
      {settings.publicSecurityFilingNumber && <a href={settings.publicSecurityFilingUrl || 'https://beian.mps.gov.cn/'} target="_blank" rel="noopener noreferrer">{settings.publicSecurityFilingIcon && <img src={settings.publicSecurityFilingIcon} alt="公安备案" />}{settings.publicSecurityFilingNumber}<ExternalLink size={12} /></a>}
    </div>
  </footer>;
}
